import { render, staticRenderFns } from "./UniteColoniesOrRemoveQueen3.vue?vue&type=template&id=dd868606&scoped=true&"
import script from "./UniteColoniesOrRemoveQueen3.vue?vue&type=script&lang=js&"
export * from "./UniteColoniesOrRemoveQueen3.vue?vue&type=script&lang=js&"
import style0 from "./UniteColoniesOrRemoveQueen3.vue?vue&type=style&index=0&id=dd868606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd868606",
  null
  
)

export default component.exports